import { Directive, Input } from '@angular/core';
import { ObservableCollection, ReadonlyRuleResult, RuleResult, ViolationSeverity } from '@skylab-shared/core';
import { Subject } from 'rxjs';
import { ViewValidationReadonlyItem, ViewValidationViolationItem } from './validate.directive';

export const VALIDATION_KEY_ATTRIBUTE = 'validation-key';

export type ValidationResult = {
    source: {
        sun: string;
    };
    propertyName: string;
    ruleViolation: {
        violation: {
            severity: ViolationSeverity;
            message: string;
            messageParams?: unknown;
        };
    };
};

export type ValidationSource = {
    validationResult: ObservableCollection<ValidationResult>;
    requiredProperties?: ObservableCollection<RuleResult>;
    readonlyProperties?: ObservableCollection<ReadonlyRuleResult & RuleResult>;
};

@Directive({ selector: '[sklValidationSource]' })
export class ValidationSourceDirective {
	@Input({required: true, alias: 'sklValidationSource'}) public source!: {
		violationsValidations: Map<string, ViewValidationViolationItem & {changed: boolean}>,
		violationValidation$: Subject<{key: string, validation: ViewValidationViolationItem}>

		readonlyValidations: Map<string, ViewValidationReadonlyItem>,
		readonlyValidation$: Subject<{key: string, validation: ViewValidationReadonlyItem}>;
	};
}
